var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30435 2.0011C4.02472 2.0011 4.6087 2.58508 4.6087 3.30545V19.3924H20.6957C21.416 19.3924 22 19.9764 22 20.6968C22 21.4171 21.416 22.0011 20.6957 22.0011H3.30435C2.58398 22.0011 2 21.4171 2 20.6968V3.30545C2 2.58508 2.58398 2.0011 3.30435 2.0011Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5659 5.34253C22.0965 5.84168 22.1459 6.70348 21.6763 7.26743L16.8029 13.12C16.5728 13.3964 16.2472 13.5618 15.9004 13.5785C15.5535 13.5952 15.2152 13.4618 14.9625 13.2087L12.0173 10.259L7.93922 14.5999C7.43858 15.1328 6.6263 15.1334 6.12494 14.6013C5.62358 14.0691 5.62299 13.2057 6.12364 12.6728L11.0823 7.39454C11.5727 6.87252 12.3647 6.85971 12.8699 7.36561L15.7588 10.259L19.755 5.45987C20.2246 4.89592 21.0353 4.84339 21.5659 5.34253Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.ff29fd83.svg";
export { ForwardRef as ReactComponent };